export const PAN_THRESHOLD_INR = 2000;

const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

export function formatPanInput(value: string): string {
  return value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 10);
}

export function isValidPan(value: string): boolean {
  return PAN_REGEX.test(formatPanInput(value));
}
